import { render, staticRenderFns } from "./HolidaysBalanceTable.vue?vue&type=template&id=45d65c4d&scoped=true"
import script from "./HolidaysBalanceTable.vue?vue&type=script&lang=js"
export * from "./HolidaysBalanceTable.vue?vue&type=script&lang=js"
import style0 from "./HolidaysBalanceTable.vue?vue&type=style&index=0&id=45d65c4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d65c4d",
  null
  
)

export default component.exports